import React from "react";
import CustomTable from "../../../../../components/table/CustomTable";
import {IncomingTableApp} from "../Functionality/IncomingTableApp";
import InvitationMainHeader from "./InvitationMainHeader";
import ConfirmModal from "../Modal/ConfirmModal";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import IncomingInvitationDetailsModal from "../Modal/IncomingInvitationDetailsModal";
import {INVITATION_VIEW_TYPE} from "../Model/Model";
import CopyInvitationLinkModal from "../Modal/CopyInvitationLinkModal";

/**
 * @email kpozos@ibl.mx
 * @author Karen Yunuen Pozos Arias
 * @title Full Stack Developer
 */

const IncomingTable = (props) => {
    const {
        selectedList,
        setSelectedList,
        subView,
        handleSubViewChange,
        searchElement,
        setSearchElement,
        setBodyForExport,
        criteria,
        setCriteria,
        finalArray,
        setFinalArray,
        search,
        setSearch,
        modified,
        setModified
    } = props;

    const {
        t,
        DEV,
        userId,
        permission,
        setResults,
        option,
        page,
        rowsPerPage,
        setSimpleSearch,
        tableId,
        searchId,
        isAllChecked,
        thead,
        tbody,
        confirmModal,
        setConfirmModal,
        action,
        detailsModal,
        setDetailsModal,
        itemSelected,
        setItemSelected,
        invitationLinkModal,
        setInvitationLinkModal,
        pagination,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
        confirmFn,
    } = IncomingTableApp({
        selectedList,
        setSelectedList,
        criteria,
        setCriteria,
        searchElement,
        finalArray,
        setSearch,
        modified,
        setModified
    });

    return (
        <>
            <InvitationMainHeader
                subView={subView}
                handleSubViewChange={handleSubViewChange}
                searchId={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                option={option}
                page={page}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                setFinalArray={setFinalArray}
                DEV={DEV}
                permission={permission}
                userId={userId}
                viewType={INVITATION_VIEW_TYPE.INCOMING}
            />

            <div className={"mt-3"}>
                <CustomTable
                    tableId={tableId}
                    searchId={searchId}
                    checkbox={false}
                    checkboxTitle={"de_/_select_all"}
                    isAllChecked={isAllChecked}
                    onChangeCheckbox={handleDeleteAll}
                    thead={thead}
                    tbody={tbody}
                    columnActions={true}
                    getActionsButtons={getActionsButtons}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedList={selectedList}
                    childrenNotInformation={tbody?.data?.length === 0 ? <>
                            <div className={"warning-text"}>
                                <p>{t("you_dont_have_any_invitations_yet")}.</p>
                            </div>
                        </>
                        : undefined
                    }
                />
                {pagination()}
            </div>

            <IncomingInvitationDetailsModal
                show={detailsModal}
                onHide={() => {
                    setDetailsModal(false);
                    setSelectedList([]);
                    setItemSelected(null);
                }}
                itemSelected={itemSelected}
            />

            <ConfirmModal
                show={confirmModal}
                onHide={() => setConfirmModal(false)}
                onClickFn={() => {
                    confirmFn(selectedList);
                    setConfirmModal(false);
                }}
                title_modal={action === STATUS_MODEL.ACCEPTED ? 'accept_invitation':
                                action === STATUS_MODEL.REJECTED ? 'reject_invitation':
                                    'cancel_invitation'}
                isReset={() => setSelectedList([])}
                description={action === STATUS_MODEL.ACCEPTED ? t("are_you_sure_you_want_to_accept_the_invitation"):
                    action === STATUS_MODEL.REJECTED ? t("are_you_sure_you_want_to_reject_the_invitation"):
                        t("are_you_sure_you_want_to_cancel_the_invitation")}
            />

            {invitationLinkModal && itemSelected &&
                <CopyInvitationLinkModal
                    show={invitationLinkModal}
                    setShow={setInvitationLinkModal}
                    itemSelected={itemSelected}
                    setItemSelected={setItemSelected}
                    setSelectedList={setSelectedList}
                />
            }
        </>
    );
};

export default IncomingTable;
